import React from "react";
import moment from "moment-timezone";
import * as util from "../../../util";
import uniqueId from "lodash/uniqueId";
import { ListDivider } from "material-ui";

import GridList from "./grid-list.jsx";
import LinkLike from "../link-like.jsx";

import {
  AutoSizer,
  List as VirtualizedList,
  WindowScroller,
  CellMeasurer,
  CellMeasurerCache
} from "react-virtualized";
import "react-virtualized/styles.css"; // only needs to be imported once

const cache = new CellMeasurerCache({
  defaultHeight: 64,
  minHeight: 48,
  fixedWidth: true
});

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      virtualItems: [],
      hasPastEvents: false
    };

    this._renderSupplementaryItem = this._renderSupplementaryItem.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.renderGridListItem = this.renderGridListItem.bind(this);

    this.renderVirtualizedItem = this.renderVirtualizedItem.bind(this);
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  static contextTypes = {
    isLarge: React.PropTypes.bool
  };

  static defaultProps = {
    groupItemsBy: "day" // options: ['day', 'month']
  };

  componentWillReceiveProps(newProps) {
    var {
        items,
        virtualItems,
        timeGetter,
        endTimeGetter,
        secondarySortGetter,
        ListItem,
        hideDateHeaders,
        hideActions,
        hidePastHeader,
        offerFetchPast,
        listItemProps,
        dontBreakIntoSections,
        groupItemsBy,
        viewMode
      } = newProps,
      now = new Date(),
      futureEvents = {},
      pastEvents = {},
      undatedEvents = [],
      virtualEvents = []

    Object.keys(items).forEach(k => {
      if (items[k].is_dated !== false) {
        items[k].moment = moment(timeGetter(items[k]));
        if (endTimeGetter) {
          items[k].endMoment = moment(endTimeGetter(items[k]));
        } else {
          items[k].endMoment = items[k].moment;
        }
      }
      if (secondarySortGetter) {
        items[k].secondarySortKey = secondarySortGetter(items[k]);
      }
    });

    Object.keys(items)
      .sort(function (a, b) {
        const diff =
          items[a].is_dated !== false
            ? items[a].moment.diff(items[b].moment)
            : false;
        if (diff) {
          return diff;
        } else if (items[a].secondarySortKey && items[b].secondarySortKey) {
          // secondary sort alphabetically if available
          return items[a].secondarySortKey.localeCompare(
            items[b].secondarySortKey
          );
        }
      })
      .forEach(function (id) {
        var item = items[id],
          days = {};
        if (item.is_dated !== false) {
          var day =
            groupItemsBy === "day"
              ? item.moment.clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              : groupItemsBy === "month"
              ? item.moment.clone().set({ date: 1, hour: 0, minute: 0, second: 0, millisecond: 0 })
              : item.moment.clone(),
            key = (dontBreakIntoSections || groupItemsBy === "none") ? "now" : day.toISOString(),
            days =
              !hidePastHeader && item.endMoment.isBefore(now)
                ? pastEvents
                : futureEvents;

          if (!days[key]) {
            days[key] = [day, []];
          }
          days[key][1].push(item);
        } else {
          if (item.is_virtual && !item.exclude_from_virtual) {
            virtualEvents.push(item);
          } else if (!item.is_virtual) {
            undatedEvents.push(item);
          }
        }
      });

    function makeSections(days, flat, reversed) {
      let sections = Object.keys(days)
        .sort()
        .map(function (key) {
          var r = days[key];
          return (
            hideDateHeaders
              ? []
              : [{ type: "date", content: r[0], displayAs: groupItemsBy }]
          ).concat(r[1]);
        });

      if (reversed) {
        sections.reverse();
      }

      // if (!hideDateHeaders) {
      //   sections = util.intersperse(sections, {type: 'divider'});
      // }

      if (flat) {
        return [].concat.apply([], sections);
      } else {
        return sections;
      }
    }

    // During the festival, show most recent past events at the top. However, once it's all done,
    // show it in true chronological order for historical record.
    // Note: for the Schedule page, we assume 'viewmode' is set.
    let shouldReversePast = Object.keys(futureEvents).length > 0;

    let listableItems = []
      .concat(
        undatedEvents.length
          ? [{ type: "date", rawContent: "Undated events" }]
          : []
      )
      .concat(undatedEvents)
      .concat(
        ((Object.keys(futureEvents).length || Object.keys(pastEvents).length) && viewMode)
          ? [{ type: "date", rawContent: "Events by date" }]
          : []
      )
      .concat(makeSections(futureEvents, true))
      .concat(
        virtualEvents.length
          ? [{ type: "date", rawContent: "Virtual screenings" }]
          : []
      )
      .concat(virtualEvents)
      .concat(
        hidePastHeader || (!offerFetchPast && !Object.keys(pastEvents).length)
          ? []
          : [{ type: "past-header" }]
      )
      .concat(makeSections(pastEvents, true, shouldReversePast)); //reversed=true so most recent past events appear at the top

    this.setState(
      {
        items: listableItems,
        hasPastEvents: !!Object.keys(pastEvents).length
      },
      () => {
        cache.clearAll();
        if (this.list) {
          this.list.recomputeRowHeights();
        }
      }
    );
  }

  getStyles() {
    return {
      pastHeader: {
        textAlign: "center",
        marginTop: 40
      },
      fetchPast: {
        fontSize: "1.1em",
        textAlign: "center",
        marginTop: -10,
        marginBottom: 20
      },
      header: this.context.isLarge
        ? {
            color: "rgba(0, 0, 0, 0.54)",
            fontSize: 15,
            fontWeight: 500,
            lineHeight: "48px",
            paddingLeft: 16
          }
        : {
            color: "rgba(0, 0, 0, 0.54)",
            fontSize: 16,
            fontWeight: "bold",
            lineHeight: "48px",
            textAlign: "center"
          }
    };
  }

_renderSupplementaryItem(item, key) {
  let styles = this.getStyles();

  if (item.type === "date") {
    const { viewMode, groupItemsBy } = this.props;

    // Suppress date headers when in cover view and grouping is none
    if (viewMode === "cover" && groupItemsBy === "none") {
      return null;
    }

    return (
      <div style={styles.header} key={key}>
        {item.rawContent
          ? item.rawContent
          : item.displayAs === "day"
          ? item.content.format(
              `dddd, MMMM D${
                item.content.isSame(moment(), "year") ? "o" : ", Y"
              }`
            )
          : item.displayAs === "month"
          ? item.content.format(`MMMM Y`)
           : item.displayAs === "none"
          ? ""
          : "?????????"}
      </div>
    );
  }

    if (item.type === "past-header") {
      return (
        <div key={key}>
          <h2 style={styles.pastHeader}>Past events</h2>
          {this.props.offerFetchPast ? (
            <div style={styles.fetchPast}>
              {this.props.fetchingPast ? (
                "Loading..."
              ) : (
                <LinkLike onClick={() => this.props.fetchPast()}>
                  Load {this.state.hasPastEvents ? "remaining" : ""} past events
                </LinkLike>
              )}
            </div>
          ) : null}
        </div>
      );
    }

    if (item.type === "divider") {
      return <ListDivider key={key} />;
    }

    return null;
  }

  renderItem(index, key) {
    let item = this.state.items[index];

    let rendered = this._renderSupplementaryItem(item, key);
    if (rendered) {
      return rendered;
    }

    let {
      ListItem,
      hideDateHeaders,
      hideActions,
      listItemProps,
      compact,
      groupItemsBy,
      showDividers
    } = this.props;
    return (
<ListItem
  key={key}
  item={item}
  compact={compact || this.props.viewMode === "compact"}
 includeDateInCompact={groupItemsBy === "month" || groupItemsBy === "none"}
  groupItemsBy={groupItemsBy} // <-- add this line
  showExtended={hideDateHeaders}
  hideActions={hideActions}
  showBottomBorder={showDividers && index < this.state.items.length - 1}
  {...listItemProps}
/>
    );
  }

  renderVirtualizedItem({
    index, // Index of row
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    key, // Unique key within array of rendered rows
    parent, // Reference to the parent List (instance)
    style // Style object to be applied to row (to position it)
  }) {
    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        <div style={style}>{this.renderItem(index, key)}</div>
      </CellMeasurer>
    );
  }

  renderGridListItem(item, key) {
    let rendered = this._renderSupplementaryItem(item, key);
    if (rendered) {
      return rendered;
    }

    let { GridListItem, hideDateHeaders, hideActions, gridListItemProps, groupItemsBy } =
      this.props;
    return (
      <GridListItem
        key={key}
        item={item}
        showExtended={hideDateHeaders}
        hideActions={hideActions}
        groupItemsBy={groupItemsBy} // <-- add this line
        {...gridListItemProps}
      />
    );
  }

  getOverscanIndices({
    direction, // One of "horizontal" or "vertical"
    cellCount, // Number of rows or columns in the current axis
    scrollDirection, // 1 (forwards) or -1 (backwards)
    overscanCellsCount, // Maximum number of cells to over-render in either direction
    startIndex, // Begin of range of visible cells
    stopIndex // End of range of visible cells
  }) {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  }

  render() {
    if (this.props.viewMode === "grid") {
      return (
        <GridList
          items={this.state.items}
          virtualItems={this.state.virtualItems}
          itemRenderer={this.renderGridListItem}
        />
      );
    } else {
      const isVirtualizedMode = this.props.useVirtualizedMode;

      if (isVirtualizedMode) {
        return (
          <div style={{ width: "100%" }}>
            <WindowScroller>
              {({
                height,
                isScrolling,
                onChildScroll,
                scrollTop,
                registerChild
              }) => (
                <AutoSizer disableHeight>
                  {({ width }) => (
                    <div ref={registerChild}>
                      <VirtualizedList
                        ref={r => {
                          this.list = r;
                        }}
                        overscanIndicesGetter={this.getOverscanIndices}
                        overscanRowCount={20}
                        autoHeight
                        height={height}
                        isScrolling={isScrolling}
                        onScroll={onChildScroll}
                        rowCount={this.state.items.length}
                        rowRenderer={this.renderVirtualizedItem}
                        deferredMeasurementCache={cache}
                        rowHeight={cache.rowHeight}
                        scrollTop={scrollTop}
                        width={width}
                      />
                    </div>
                  )}
                </AutoSizer>
              )}
            </WindowScroller>
          </div>
        );
      }

      return (
        <div key="list">
          {this.state.items.map((item, i) =>
            this.renderItem(i, item.id || uniqueId("rootList"))
          )}
        </div>
      );
    }
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/app/components/partials/list/list.jsx